<template>
  <div>
    <router-view />
  </div>
</template>

<script setup>
// This component is intentionally simple.
// You can add any shared logic for your package's routes here.
</script>
